// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__187r1"};